import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../common/Sidebar';
import Header from '../common/Header';
import '../../index.css';

const AdminLayout = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const getPageTitle = (path) => {
    switch (path) {
      case '/dashboard': return 'Dashboard';
      case '/products': return 'Products Management';
      case '/orders': return 'Orders Management';
      case '/customers': return 'Customers Directory';
      case '/inventory': return 'Inventory & Stock';
      case '/reports': return 'Sales & Analytics Reports';
      case '/promotions': return 'Promotions & Discounts';
      case '/settings': return 'Admin Settings';
      case '/users': return 'Users & Access Control';
      case '/activity-logs': return 'System Activity Logs';
      default: return 'Admin Panel';
    }
  };

  const title = getPageTitle(location.pathname);

  return (
    <div className="admin-layout">
      {/* Mobile Drawer Overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-drawer-overlay"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}

      {/* Sidebar Component */}
      <div className={`sidebar-responsive-wrapper ${mobileMenuOpen ? 'drawer-open' : ''}`}>
        <Sidebar onCloseMobile={() => setMobileMenuOpen(false)} />
      </div>

      {/* Main Content Area */}
      <div className="admin-main-container">
        <Header
          title={title}
          onToggleMobileMenu={() => setMobileMenuOpen(!mobileMenuOpen)}
          mobileMenuOpen={mobileMenuOpen}
        />
        <main className="dashboard-body">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
